import { render, staticRenderFns } from "./growth.vue?vue&type=template&id=a8831542&scoped=true&"
import script from "./growth.vue?vue&type=script&lang=js&"
export * from "./growth.vue?vue&type=script&lang=js&"
import style0 from "./growth.vue?vue&type=style&index=0&id=a8831542&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8831542",
  null
  
)

export default component.exports